import { createStandaloneToast } from '@chakra-ui/react';

const { toast } = createStandaloneToast();

const ALLOWED_ROUTES = ['/', '/live-games', '/games/cricket', '/games/soccer', '/games/tennis', '/live-casino'];

export const isComingSoonRoute = (route) => {
  if (ALLOWED_ROUTES.includes(route)) return false;
  if (route.startsWith('/live-casino/')) return false;
  if (route.startsWith('/card-games')) return false;
  if (route.startsWith('/game/cricket/')) return false;
  if (route.startsWith('/game/soccer/')) return false;
  if (route.startsWith('/game/tennis/')) return false;
  if (route === '/sports-book') return true;
  return route.startsWith('/games/') || route.startsWith('/game/');
};

export const showComingSoonToast = () => {
  toast.closeAll();
  toast({
    title: 'Coming Soon!',
    description: 'This sport will be available shortly. Stay tuned!',
    status: 'info',
    duration: 2500,
    isClosable: true,
    position: 'top',
  });
};
